import {
  orderBy,
  query,
  QueryFieldFilterConstraint,
  where,
} from 'firebase/firestore';
import { QueryFilterOptions } from 'shared/types/filter';
import { ID } from 'shared/types/id';
import { TaskType } from 'shared/types/task-base';

import { taskConverter } from './converters/task';
import { CollectionOptions, getCollection } from './helpers';

export const getFilteredTasks = async (
  uid: ID,
  filters: QueryFilterOptions,
) => {
  const conditions = [
    where('roles.all', 'array-contains', uid),

    !filters.showCompleted && where('completedAt', '==', null),

    !!filters.tasksOnly && where('type', '==', TaskType.Task),
    !!filters.ids?.length && where('id', 'in', filters.ids),
    filters.lifeAreas?.length && where('lifeAreaId', 'in', filters.lifeAreas),
    !!filters.noLifeArea &&
      !filters.lifeAreas?.length &&
      where('lifeAreaId', '==', null),
    filters.goals?.length && where('goalId', 'in', filters.goals),
    !!filters.noGoal && !filters.goals?.length && where('goalId', '==', null),
    filters.deadlineDeadlineStartDate !== undefined &&
      where('deadlineDeadline', '>=', filters.deadlineDeadlineStartDate),
    filters.deadlineDeadlineEndDate !== undefined &&
      where('deadlineDeadline', '<=', filters.deadlineDeadlineEndDate),
    !!filters.noDeadlineDeadline && where('deadlineDeadline', '==', null),
    !!filters.hasDeadlineDeadline && where('deadlineDeadline', '!=', null),
    filters.deadlineStartDate !== undefined &&
      where('endStrategy.deadline', '>=', filters.deadlineStartDate),
    filters.deadlineEndDate !== undefined &&
      where('endStrategy.deadline', '<=', filters.deadlineEndDate),
    !!filters.noDeadline && where('endStrategy.deadline', '==', null),
    !!filters.hasDeadline && where('endStrategy.deadline', '!=', null),
    // Only narrow Firestore reads by completedAt when the consumer is
    // explicitly fetching completed tasks. Otherwise, range constraints on
    // completedAt would exclude null-valued (uncompleted) tasks that other
    // pages still expect to receive.
    !!filters.showCompleted &&
      filters.completedStartDate !== undefined &&
      where('completedAt', '>=', filters.completedStartDate),
    !!filters.showCompleted &&
      filters.completedEndDate !== undefined &&
      where('completedAt', '<=', filters.completedEndDate),
  ].filter(Boolean) as QueryFieldFilterConstraint[];

  return query(
    getCollection(CollectionOptions.Tasks).withConverter(taskConverter),
    ...conditions,
    orderBy('createdAt', 'asc'),
  );
};
